/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  organizationService,
  changesService,
  OrganizationFinancialPositionBuffers,
  navigationService,
  helperService,
  uiService
) => {
  $scope.Model = {
    organizationCountry: helperService.getOrganizationCountry(),
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    organizationService
      .readOrganization({ id: $rootScope.CurrentOrganization.id })
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        // eslint-disable-next-line no-param-reassign
        $rootScope.CurrentOrganization.financialPositionBuffers = OrganizationFinancialPositionBuffers.build(
          data.financialPositionBuffers
        );
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Financial position buffers : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Helper Methods
   * --------------------------------------------------------------------------------
   */
  $scope.isOwner = () =>
    $rootScope.CurrentAccount.id === $rootScope.CurrentOrganization.idOwner;

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      financialPositionBuffers: $rootScope.CurrentOrganization.financialPositionBuffers
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
